import axios from 'axios';

export default class HttpClient {
    #apiToken;

    constructor() {
        this.#bindVariables();
    }

    #bindVariables() {
        this.#apiToken = document.querySelector('meta[name="api-token"]')?.content;
    }

    #getConfig() {
        return {
            headers: {
                Authorization: 'Bearer ' + this.#apiToken,
            },
        };
    }

    get(url, config = {}) {
        return axios.get(url, {
            ...this.#getConfig(),
            ...config,
        });
    }

    post(url, data) {
        return axios.post(url, data, this.#getConfig());
    }

    delete(url) {
        return axios.delete(url, this.#getConfig());
    }

    method(args) {
        return axios({
            ...args,
            ...this.#getConfig(),
        });
    }
}
